import axios from "../../utils/axiosInstance";

export const partnerOnBoardingCheckReactive = async () => {
    const response = await axios.post("/partnerOnBoardingCheckReactive", {});
    return response.data;
};
